import React, { useEffect, useState } from 'react';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
import { SCROLL_THROTTLE_TIMEOUT } from '../constants';

export type OverflowTypes = 'left' | 'right' | 'both' | '';

/** Calculate overflow tyoe */
export function useSliderOverflow(
  contentRef: React.RefObject<HTMLElement | null>,
  itemCount: number
) {
  const [overflow, setOverflow] = useState<OverflowTypes>('');

  const updateOverflow = useThrottle(
    () => {
      let newOverflow: OverflowTypes = '';

      if (!contentRef.current) {
        return newOverflow;
      }

      const contentRect = contentRef.current.getBoundingClientRect();
      const scrollLeft = contentRef.current.scrollLeft;
      const scrollWidth = contentRef.current.scrollWidth;
      const scrollRight = scrollWidth - scrollLeft - contentRect.width;
      const overflowedLeft = Math.floor(scrollLeft) >= 1;
      const overflowedRight = Math.floor(scrollRight) >= 1;

      if (overflowedLeft && overflowedRight) {
        newOverflow = 'both';
      } else if (overflowedLeft) {
        newOverflow = 'left';
      } else if (overflowedRight) {
        newOverflow = 'right';
      }

      setOverflow(newOverflow);
    },
    [],
    SCROLL_THROTTLE_TIMEOUT,
    { leading: true }
  );

  useEffect(() => {
    const contentNode = contentRef.current;
    updateOverflow();

    window.addEventListener('resize', updateOverflow);
    contentNode?.addEventListener('scroll', updateOverflow);
    return () => {
      window.removeEventListener('resize', updateOverflow);
      contentNode?.removeEventListener('scroll', updateOverflow);
    };
  }, [updateOverflow, contentRef]);

  // Refresh arrow state when we detect item count changed
  useEffect(() => {
    updateOverflow();
  }, [updateOverflow, itemCount]);

  return overflow;
}
